import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class RevenuePerAvailableRoom extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'start',
    'end',
    'revpar',
    'rooms_booked',
    'total_revenue',
    'revpar_compare',
    'rooms_booked_compare',
    'total_revenue_compare',
    'change',
    'revpar_pace',
)(RevenuePerAvailableRoom);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/production/revenue-per-available-room.model.js